import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [checking, setChecking] = useState(true);  // 添加检查状态

  // 获取管理员用户信息
  useEffect(() => {
    const userStr = localStorage.getItem('admin_user');
    if (userStr) {
      try {
        setAdminUser(JSON.parse(userStr));
      } catch {
        localStorage.removeItem('admin_user');
        localStorage.removeItem('admin_token');
        navigate('/admin/login', { replace: true });
      }
    } else {
      navigate('/admin/login', { replace: true });
    }
    setChecking(false);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin', label: '仪表盘', icon: '📊' },
    { path: '/admin/users', label: '用户管理', icon: '👥' },
    { path: '/admin/roles', label: '角色权限', icon: '🔐' },
    { path: '/admin/messages', label: '留言管理', icon: '💬' },
    { path: '/admin/logs/login', label: '登录日志', icon: '📝' },
    { path: '/admin/logs/operation', label: '操作日志', icon: '📋' },
    { path: '/admin/stats', label: '数据统计', icon: '📈' },
    { path: '/admin/settings', label: '系统设置', icon: '⚙️' },
    { path: '/admin/history', label: '历史记录', icon: '📁' },
    { path: '/admin/announcements', label: '公告管理', icon: '📢' },
  ];

  // 加载中状态
  if (checking) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: 16,
        color: '#666'
      }}>
        验证登录状态...
      </div>
    );
  }

  // 未登录状态
  if (!adminUser) {
    return null;
  }

  return (
    <div className="admin-layout">
      {/* 侧边栏 */}
      <aside className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h2>{sidebarCollapsed ? '后台' : '管理后台'}</h2>
          <button 
            className="collapse-btn"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          >
            {sidebarCollapsed ? '→' : '←'}
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/admin'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {!sidebarCollapsed && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <NavLink to="/" className="nav-item" target="_blank">
            <span className="nav-icon">🏠</span>
            {!sidebarCollapsed && <span className="nav-label">访问前台</span>}
          </NavLink>
          <button className="nav-item logout-btn" onClick={handleLogout}>
            <span className="nav-icon">🚪</span>
            {!sidebarCollapsed && <span className="nav-label">退出登录</span>}
          </button>
        </div>
      </aside>

      {/* 主内容区 */}
      <main className="admin-main">
        <header className="admin-header">
          <div className="header-left">
            <h1>智能公文排版系统 - 管理后台</h1>
          </div>
          <div className="header-right">
            <span className="user-info">
              管理员: <strong>{adminUser?.username}</strong>
            </span>
          </div>
        </header>
        
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
